<div *ngIf="isLoaded; else loading" class="calendar-wrapper">
  <h1 class="modal_title_container title-container" mat-dialog-title>
    <span class="title_box active">{{ title }} | {{ time }}</span>
    <i class="icon-close" (click)="onClose()"></i></h1>
  <div mat-dialog-content class="p-0">
	<app-patient-bio [appointment]="appointment" [patientId]="appointment.patientId" (closeEvent)="onClose()"></app-patient-bio>
  </div>
</div>

<ng-template #loading>
  <skeleton-loader type="modal-1"></skeleton-loader>
</ng-template>
